import { Box, createTheme, Grid, Theme, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import React, { FC } from "react";
import { PageContainer } from "./PageContainer";
import { push } from "redux-first-history";
import { Routes } from "#/config";
import { UncontrolledCommandLine } from "../commmandLine/UncontrolledCommandLine";
import { useAppDispatch } from "#store";
import { generateUrl } from "#components/App/routing/generateUrl";
import { generatePath } from "react-router";
import DatasourceSelector from "#components/DatasourceSelector";
import { ActionType } from "#services/pilotService/types";

export const NlSearch = () => {
    const dispatch = useAppDispatch();

    const theme = createTheme();
    const stripe2: SxProps<Theme> = {
        minHeight: "60vh",
    };

    const searchBar: SxProps<Theme> = {
        paddingTop: "4rem",
    };

    const [error, setError] = React.useState<boolean>(false);

    return (
        <PageContainer>
            <Grid
                item
                sx={{ ...stripe2 }}
                container
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs={12}>
                    <Typography variant="h1" align="center">
                        NL-Search
                    </Typography>
                    <Box sx={{ ...searchBar }}>
                        <UncontrolledCommandLine
                            onSubmit={s => {
                                if (!s || s.length === 0) {
                                    setError(true);
                                } else {
                                    setError(false);
                                    dispatch(
                                        push(
                                            generateUrl(
                                                generatePath(
                                                    Routes.triggerAction.path
                                                ),
                                                {
                                                    q: s,
                                                    op: ActionType.NL2SQL,
                                                }
                                            )
                                        )
                                    );
                                    // dispatch(push(Routes.actions.path));
                                    // dispatch(triggerExploreByNl({ query: s }));
                                }
                            }}
                        />
                        <br />

                        {error ? (
                            <Typography
                                sx={{ color: theme.palette.error.main }}
                            >
                                {" "}
                                Please enter a query{" "}
                            </Typography>
                        ) : (
                            ""
                        )}
                    </Box>
                </Grid>
            </Grid>
        </PageContainer>
    );
};
